import { OverlayTrigger, Tooltip } from "react-bootstrap";
import styled from "styled-components";

import {
  QuoteStatus,
  QuoteStatusDescription,
  quoteStatusTitle,
  QuoteStatusWaitingDescriptionByPaymentMethod,
} from "types/enums";

interface QuoteStatusProps {
  quoteStatus: number;
  paymentMethod?: number;
}

/* Mapa de cores semânticas por status — usa CSS variables, adapta ao dark mode */
const STATUS_STYLES: Record<
  number,
  { bg: string; color: string; border: string }
> = {
  [QuoteStatus.Quote]: {
    bg: "rgba(107,114,128,0.12)",
    color: "var(--gray-dark)",
    border: "rgba(107,114,128,0.25)",
  },
  [QuoteStatus.WaitingApproval]: {
    bg: "rgba(217,119,6,0.12)",
    color: "#d97706",
    border: "rgba(217,119,6,0.3)",
  },
  [QuoteStatus.Analyzing]: {
    bg: "rgba(217,119,6,0.12)",
    color: "#d97706",
    border: "rgba(217,119,6,0.3)",
  },
  [QuoteStatus.Approved]: {
    bg: "rgba(6,182,212,0.12)",
    color: "#22d3ee",
    border: "rgba(6,182,212,0.3)",
  },
  [QuoteStatus.Schedule]: {
    bg: "rgba(59,130,246,0.12)",
    color: "#3b82f6",
    border: "rgba(59,130,246,0.3)",
  },
  [QuoteStatus.Finished]: {
    bg: "rgba(var(--primary-rgb),0.12)",
    color: "var(--primary)",
    border: "rgba(var(--primary-rgb),0.3)",
  },
  [QuoteStatus.Canceled]: {
    bg: "rgba(239,68,68,0.12)",
    color: "#f87171",
    border: "rgba(239,68,68,0.3)",
  },
};

const StatusPill = styled.span<{
  $bg: string;
  $color: string;
  $border: string;
}>`
  display: inline-flex;
  align-items: center;
  font-size: 0.6875rem;
  font-weight: 700;
  padding: 0.25rem 0.625rem;
  border-radius: 2rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  white-space: nowrap;
  cursor: default;
  background: ${({ $bg }) => $bg};
  color: ${({ $color }) => $color};
  border: 1px solid ${({ $border }) => $border};
  transition: var(--transition);
`;

const QuoteStatusInfo = ({ quoteStatus, paymentMethod }: QuoteStatusProps) => {
  const style = STATUS_STYLES[quoteStatus] ?? STATUS_STYLES[QuoteStatus.Quote];

  return (
    <OverlayTrigger
      placement="top"
      overlay={
        <Tooltip>
          <b>
            {quoteStatus !== 2 || paymentMethod === undefined
              ? QuoteStatusDescription[quoteStatus]
              : QuoteStatusWaitingDescriptionByPaymentMethod[paymentMethod]}
          </b>
        </Tooltip>
      }
    >
      <StatusPill
        $bg={style.bg}
        $color={style.color}
        $border={style.border}
        aria-label={`Status: ${quoteStatusTitle.get(quoteStatus)}`}
      >
        {quoteStatusTitle.get(quoteStatus)}
      </StatusPill>
    </OverlayTrigger>
  );
};

export default QuoteStatusInfo;
